export enum TransitionTimingFunction {
    linear,
    ease,
    'ease-in',
    'ease-out',
    'ease-in-out',
}
